import { GlobalToken } from 'antd/es/theme/interface'
import { CellValidator } from '../cell-validators'
import { isDurstMachine } from '../is-durst-machine'

export const validateDurstAndGf: CellValidator = (record, token: GlobalToken) => {
    if (!isDurstMachine(record.machine)) {
        return null
    }

    const hasGf = record.additional_machines?.some((m: { name?: string }) => m.name?.includes('GF'))
    if (!hasGf) {
        return {
            message: 'Для машины Durst необходимо обязательно выбрать GF в качестве отделочной машины',
            bgColor: token.colorErrorBg,
            color: token.colorErrorText || token.colorError,
        }
    }

    return null
}
